import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import {
	type HttpGetAdminServiceVersions,
	httpGetAdminServiceVersions
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { ServiceVersion } from '@/features/service-vetting/types.ts'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetServiceVersions = (
	urlParams: HttpGetAdminServiceVersions['urlParams'],
	options?: UseQueryOptions<ServiceVersion[]>
) => {
	const query = useQuery({
		queryKey: [QUERY_KEYS.SERVICE_VETTING, urlParams],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetAdminServiceVersions({
					params: { response_type: 'extended' },
					urlParams
				}),
				responseShape: z.array(ServiceVersion),
				onZodError: captureException
			}),
		...options
	})

	return { ...query, remappedData: query.data ? query.data : [] }
}
